import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { DarkModeContext } from "../context/DarkModeContext";

const Sidebar = ({ isOpen, closeSidebar }) => {
  const role = localStorage.getItem("role");
  const { darkMode } = useContext(DarkModeContext);

  const bgClass = darkMode ? "bg-gray-800" : "bg-gray-100";
  const textClass = darkMode ? "text-white" : "text-gray-900";
  const hoverClass = darkMode ? "hover:bg-gray-700" : "hover:bg-gray-300";

  return (
    <div
      className={`fixed md:static inset-y-0 left-0 w-64 transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } md:translate-x-0 transition-transform duration-300 z-50 ${bgClass} shadow-lg`}
    >
      {/* HEADER */}
      <div className="p-6 border-b border-gray-300">
        <h2 className={`text-xl font-bold ${textClass}`}>Menu</h2>
      </div>

      {/* LINKS */}
      <div className="flex flex-col p-4 space-y-2">
        {role === "Manager" && (
          <Link
            to="/dashboard"
            onClick={closeSidebar}
            className={`p-2 rounded ${hoverClass} ${textClass}`}
          >
            Dashboard
          </Link>
        )}

        <Link
          to="/products"
          onClick={closeSidebar}
          className={`p-2 rounded ${hoverClass} ${textClass}`}
        >
          Products
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;